import type { FC } from "react";

import { useTranslation } from "react-i18next";

import type { OccupantFormValues } from "../hooks/use-occupant-form-schema";

import FormInputField from "./form-input-field";
import OccupantDestinationFields from "./occupant-destination-fields";

/**
 * The whole person: their name and every destination they can be alerted at.
 * The one face of the drawer — the same fields whether the contact is being
 * created or an existing one is being edited.
 */
const OccupantContactFields: FC = () => {
  const { t } = useTranslation(["occupants"]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex flex-1 flex-col gap-2">
          <span className="text-sm font-medium leading-none text-foreground">
            {t("occupants:occupants-field-first-name", "First name")}
          </span>
          <FormInputField<OccupantFormValues> name="first_name" />
        </div>

        <div className="flex flex-1 flex-col gap-2">
          <span className="text-sm font-medium leading-none text-foreground">
            {t("occupants:occupants-field-last-name", "Last name")}
          </span>
          <FormInputField<OccupantFormValues> name="last_name" />
        </div>
      </div>

      <OccupantDestinationFields />
    </div>
  );
};

export default OccupantContactFields;
